import { Api } from "../config/request";

export default {
  getInventoriesList(queryParams) {
    return Api.get(`/inventories${queryParams}`);
  },
};
